export default {
  failed: 'Failed'
}
